require('./brokerFundamentalAnalysisSearchView.scss');
const React = require('react');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const brokerFundamentalAnalysisSearchAction = require('actions/brokerFundamentalAnalysisSearch');
const { ContentBox } = require('commonsComponents/contentBox');
const BrokerFundamentalAnalysisForm = require('components/broker/brokerFundamentalAnalysisSearch/brokerFundamentalAnalysisForm/brokerFundamentalAnalysisForm');
const BrokerFundamentalAnalysisFilterType = require('components/broker/brokerFundamentalAnalysisSearch/brokerFundamentalAnalysisFilterType/brokerFundamentalAnalysisFilterType');
const BrokerFundamentalAnalysisResults = require('components/broker/brokerFundamentalAnalysisResults/brokerFundamentalAnalysisResults');

class BrokerFundamentalAnalysisSearchView extends React.Component {
    constructor(props) {
        super(props);

        this.handleRadioFilterTypeChange = this.handleRadioFilterTypeChange.bind(this);
        this.handleSubmitFormClick = this.handleSubmitFormClick.bind(this);
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: '/myprofile/broker/markets'
            },
            {
                text: formatText('breadcrumb-fundamentalAnalysis'),
                url: ''
            }
        ];
    }

    componentWillUnmount() {
        this.props.clearForm();
    }

    handleRadioFilterTypeChange(value) {
        this.props.changeSearchType(value);
    }

    handleSubmitFormClick() {
        this.props.submit();
    }

    render() {
        const { brokerFundamentalAnalysisSearch } = this.props;
        const results = brokerFundamentalAnalysisSearch.get('results');
        const selectedFilter = this.props.brokerFundamentalAnalysisSearch.get('selectedFilter');
        const immFormData = this.props.brokerFundamentalAnalysisSearch.get('formData');

        return (
            <div className="broker-fundamental-analysis-search-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.breadcrumb}
                        finalTitle={getFinalTitle('broker-fundamentalAnalysisSectionTitle')} />
                </OKCover>
                <section className="broker-fundamental-analysis-search-view__body">
                    <ContentBox
                        title={formatText('broker-fundamentalAnalysisTitle')}
                        icon="search-lens"
                        customClassName="broker-fundamental-analysis-search-view__searchbox"
                    >
                        <BrokerFundamentalAnalysisFilterType
                            selectedFilter={selectedFilter}
                            onChange={this.handleRadioFilterTypeChange}
                        />
                        <BrokerFundamentalAnalysisForm
                            immData={this.props.brokerFundamentalAnalysisSearch}
                            selectedFilter={selectedFilter}
                            immFormData={immFormData}
                            changeSector={this.props.changeSector}
                            changeDateFrom={this.props.changeDateFrom}
                            changeDateTo={this.props.changeDateTo}
                            changeValue={this.props.changeValue}
                            onSubmit={this.handleSubmitFormClick}
                        />
                    </ContentBox>

                    <section className="broker-fundamental-analysis-search-view__content clearfix">
                        <BrokerFundamentalAnalysisResults results={results} />
                    </section>
                </section>
            </div>
        );
    }
}

BrokerFundamentalAnalysisSearchView.propTypes = {
    brokerFundamentalAnalysisSearch: PropTypes.object,
    changeSearchType: PropTypes.func,
    changeSector: PropTypes.func,
    changeDateFrom: PropTypes.func,
    changeDateTo: PropTypes.func,
    changeValue: PropTypes.func,
    submit: PropTypes.func,
    clearForm: PropTypes.func
}

module.exports.constructor = BrokerFundamentalAnalysisSearchView;
module.exports.BrokerFundamentalAnalysisSearchView = connect(
    state => ({
        brokerFundamentalAnalysisSearch: state.brokerFundamentalAnalysisSearch,
    }), {
        changeSearchType: brokerFundamentalAnalysisSearchAction.changeSearchType,
        changeSector: brokerFundamentalAnalysisSearchAction.changeSector,
        changeDateFrom: brokerFundamentalAnalysisSearchAction.changeDateFrom,
        changeDateTo: brokerFundamentalAnalysisSearchAction.changeDateTo,
        changeValue: brokerFundamentalAnalysisSearchAction.changeValue,
        submit: brokerFundamentalAnalysisSearchAction.submit,
        clearForm: brokerFundamentalAnalysisSearchAction.clearForm
    })(BrokerFundamentalAnalysisSearchView);
